<template>
  <div class="banner">
    <img :src="url" alt="banner">
    <div class="banner-desc">
      <h1>上海趋致信息科技</h1>
      <p>创新与卓越的融合，积极探索创新模式</p>
      <p>凭借着专业的团队和丰富的经验</p>
      <p>在科技信息领域成为众多企业信赖的合作伙伴</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      url: require("../assets/img/banner.png"),
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
.banner {
  width: 100%;
  position: relative;
}

.banner img{
  width: 100%;
}

.banner-desc {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  padding: 22px 140px 23px;
  width: 1200px;
}

.banner-desc h1 {
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 40px;
  color: #ffffff;
  line-height: 80px;
}

.banner-desc p {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  line-height: 36px;
}
</style>
